<template>
  <form @submit="submitForm">
    <div class="form-group required my-4">
      <label for="name" class="wfh-form-label">
        What's your name?
      </label>
      <input
          required
          autofocus
          autocomplete="name"
          class="form-control wfh-input-box"
          style="background-image: none !important;"
          type="text"
          id="name"
          v-model="formData.name"/>
    </div>

    <div class="form-group d-flex flex-column my-4">
      <label for="hasHrInTeam" class="wfh-form-label">
        Is there any HR person in your team?
      </label>
      <div class="btn-group btn-group-toggle mt-2 overflow-auto" id="hasHrInTeam">
        <label
            class="btn radio-btn d-flex justify-content-center align-items-center"
            style="flex: 1;"
            v-bind:class="{ active: value == formData.has_hr }"
            v-for="(option, value) in dropDownOptions.hrOptions"
        >
          <i
              class="fas fa-check-circle mr-1 mr-md-3"
              style="font-size: 18px;"
              v-if="value == formData.has_hr"
          ></i>
          <input
              type="radio"
              name="hr_options"
              :id="value"
              v-model="formData.has_hr"
              :value="value"/>
          {{ option }}
        </label>
      </div>
    </div>

    <div class="form-group my-4" v-if="hasHr">
      <label for="hrEmail" class="wfh-form-label">
        Add Human Resource manager's email
      </label>
      <input
          required
          autocomplete="email"
          class="form-control wfh-input-box"
          style="background-image: none !important;"
          type="email"
          id="hrEmail"
          v-model="formData.hr_email"/>
    </div>

    <div class="form-group my-4">
      <label for="teamMembers" class="wfh-form-label">
        Insert your team members' emails separated by commas. (Optional)
      </label>
      <textarea
          class="form-control wfh-input-box"
          id="teamMembers"
          rows="4"
          v-model="formData.team_members"></textarea>
      <div class="wfh-small-text mt-1">We'll send them an invite email to register.</div>
    </div>

    <div class="form-group my-4 d-flex justify-content-end">
      <button type="submit" class="btn wfh-btn-primary">
        Next Step
      </button>
    </div>
  </form>
</template>

<script>
import DropDownOptions from '../DropdownOptionsConfig';

export default {
  props: {
    oldData: {
      required: false,
    },
  },

  data () {
    return {
      oldDataParsed: {},
      formData: {
        name: '',
        has_hr: 1,
        hr_email: '',
        team_members: '',
      },
      dropDownOptions: DropDownOptions,
    };
  },

  computed: {
    hasHr () {
      return this.formData.has_hr == 1;
    },

    formCompleted () {
      return (this.formData.name && (
          !this.hasHr ||
          (this.hasHr && this.formData.hr_email)
      ));
    },
  },

  watch: {
    'formData.has_hr' () {
      if (this.formData.has_hr == 3) {
        this.formData.hr_email = this.oldDataParsed.email;
      } else {
        this.formData.hr_email = '';
      }
    },
  },

  methods: {
    getHR (company) {
      if (Object.keys(company.company_hr).length === 0) {
        this.formData.has_hr = 2;
        return;
      }

      const companyHR = company.company_hr[0];

      if (companyHR.id === this.oldDataParsed.id) {
        this.formData.has_hr = 3;
        return;
      }

      this.formData.hr_email = companyHR.email;
    },

    async submitForm (e) {
      e.preventDefault();

      const formData = {
        company_id: this.oldDataParsed.companies[0].id,
      };

      Object.keys(this.formData).forEach(key => {
        if (!!this.formData[key]) {
          formData[key] = key === 'team_members' ? this.getEmailArray(this.formData[key]) : this.formData[key];
        }
      });

      await axios.post(window.location.pathname, formData);

      window.location = '/dashboard';
    },

    getEmailArray (emailsString) {
      const removedWhitespaces = emailsString.replace(/\s/g, '');

      return removedWhitespaces.split(',');
    },
  },

  mounted () {
    this.oldDataParsed = JSON.parse(this.oldData);
    this.formData.name = this.oldDataParsed.name ?? '';
    this.getHR(this.oldDataParsed.companies[0]);
  },
};
</script>

<style scoped>

</style>
